import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsimage',
	templateUrl:'./BSImagePluginCompPage.html',
	styles: [],
	styleUrls:['./BSImagePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSImagePluginCompPage
{
	mdContent_824 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.images.BSImage;
\`\`\``;
	mdContent_825 = `\`\`\`java
BSImage()
\`\`\``;
	mdContent_826 = `\`\`\`java
BSImage(String src)
\`\`\``;
	mdContent_827 = `\`\`\`java
BSImage&lt;?&gt; img = new BSImage&lt;&gt;("/img/photo.jpg");
img.setResponsive(true);
img.setThumbnail(true);
\`\`\``;
}
